import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleContent from './components/ArticleContent';

export default function Guide() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <ArticleContent />
      </main>
      <Footer />
    </div>
  );
}